module.exports = __webpack_public_path__ + "static/media/user-inverted.38eed4e2.svg";